import { List } from 'immutable'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface ISearchResultSetItemProps {
  item: any
}

export interface ISearchResultSetProps {
  title: string
  items: List<any>
  moreLink?: string
  itemComponent: React.ComponentType<ISearchResultSetItemProps>
}

export class SearchResultSet extends React.PureComponent<
  ISearchResultSetProps
> {
  public render() {
    if (this.props.items.size === 0) {
      return null
    }

    const ItemComponent = this.props.itemComponent

    const resultItems = this.props.items.map((item) => (
      <li key={item.id}>
        <ItemComponent item={item} />
      </li>
    ))

    return (
      <div>
        <div className='result-set-title'>{this.props.title}</div>
        <ul className='result-list'>{resultItems}</ul>
        {this._renderMoreLink()}
      </div>
    )
  }

  private _renderMoreLink() {
    if (!this.props.moreLink || this.props.items.size < 3) {
      return null
    }

    return (
      <div className='global-search-more'>
        <Link to={this.props.moreLink}>
          See more {this.props.title.toLowerCase()}
        </Link>
      </div>
    )
  }
}
